import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import BookingPopup from './BookingPopup';

export default function Footer() {
  const [showSerachEngine, setshowSerachEngine] = useState(false);
  return (
    <>
      <footer className="footer">
        <div className="container-fluid">
          <div className="container-wraps">
            <div className="row">
              <div className="col-md-12">
                <div className="footer-top">
                  <img src="/assets/images/footer-top-bg.webp" alt="Management" className="img-responsive " loading="lazy" />
                  <div className="footer-top-content">
                    <div className="heading">Take your Waste Management <br /> to the Next Level</div>
                    <div className="footer-btn">
                      <Link to="/contact-us/" className="theme-btn white-btn"> <span className="color-overlay"></span> <span className="btn-txt">Call us now</span></Link>
                      <Link onClick={() => setshowSerachEngine(true)} className="theme-btn white-btn"> <span className="color-overlay"></span> <span className="btn-txt">Book Online</span></Link>
                    </div>
                  </div>
                </div>
                <div className="footer-bottom">
                  <div className="row align-items-center ">
                    <div className="col-sm-12 col-md-12 col-lg-9">
                      <div className="left-sec">
                        <div className="row align-items-end">
                          <div className="col-sm-6 col-md-5 col-lg-6 ">
                            <div className="footer-details">
                              <div className="footer-logo">
                                <Link to="/">
                                  <img src="/assets/images/footer-logo.webp" className="img-responsive" alt="Footer Logo" loading="lazy" /></Link>

                              </div>
                              <div className="address">
                                <Link className="mail" to="mailto:bbinyeg@gmail.com">bbinyeg@gmail.com </Link>
                                <Link className="number" to="tel:+1 780 230 1359">+1 780 230 1359</Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <nav className="footer-links" aria-label="Footer navigation">
                              <ul className="links-items">
                                <li><Link to="/">Home  <i className="fa-solid fa-arrow-right"></i> </Link></li>
                                <li><Link to="/about-us/">About Us <i className="fa-solid fa-arrow-right"></i>  </Link></li>
                                <li><Link to="how-to-book-a-bin/">How it Works <i className="fa-solid fa-arrow-right"></i> </Link></li>
                                <li><Link to="/residential-dumpsters-edmonton/" >Services <i className="fa-solid fa-arrow-right"></i> </Link></li>
                                <li><Link to="/pricing/" >Pricing <i className="fa-solid fa-arrow-right"></i> </Link></li>
                                <li><Link to="/blogs/" >Blogs & Articles <i className="fa-solid fa-arrow-right"></i> </Link></li>
                                <li><Link to="/contact-us/" >Contact <i className="fa-solid fa-arrow-right"></i> </Link></li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-3">
                      <div className="right-flower">
                        <img src="/assets/images/footer-flower.webp" alt="Flower" className="img-responsive" loading="lazy" />
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-end">
                    <div className="col-sm-9 col-md-9 col-lg-9">
                      <div className="row align-items-end">
                        <div className="col-sm-6 col-md-5">
                          <div className="footer-heading">
                            <div className="heading">Take  waste <br /> management to  <br /> next level</div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-7">
                          <div className="footer-copyright">
                            <p className="copyrght-text">© 2026 <span>Big Bin Rentals. </span>
                              All Rights Reserved. Designed By <Link rel="noopener noreferrer" to="https://www.88gravity.com" target="_blank">88gravity</Link>  </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <div className="copyright-links">
                        <nav className="footer-links" aria-label="Legal navigation">
                          <ul className="links-items">
                            <li><Link to="/privacy-policy/">Privacy Policy</Link></li>
                            <li><Link to="/return-and-refund-policy/" >Terms & Conditions</Link></li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  )
}
